// Anasayfa içerik varsayılanları (backend ile aynı). Site, sunucudan içerik
// gelmezse bunları gösterir; admin editörü de alan etiketlerini buradan okur.

export const LANDING_TEXTS_DEFAULT = {
  nav_book: "Ücretsiz Talep Oluştur",
  nav_login: "Giriş Yap",
  hero_badge: "Doğrulanmış Temizlik Uzmanları",
  hero_title_1: "Evinizin temizliği",
  hero_title_2: "güvenilir ellerde.",
  hero_sub: "Ücretsiz talep oluşturun, güvenilir temizlik uzmanlarından dakikalar içinde teklif alın. Teklifleri karşılaştırın, beğendiğiniz uzmanla doğrudan iletişime geçin.",
  hero_cta: "Ücretsiz Talep Oluştur",
  hero_secondary: "Nasıl Çalışır?",
  nasil_badge: "Nasıl Çalışır",
  nasil_title: "3 Adımda PAK!",
  nasil_sub: "Ücretsiz talep oluşturun, teklifleri karşılaştırın, uzmanınızla anlaşın.",
  nasil_1_title: "Ücretsiz talep oluştur",
  nasil_1_desc: "İhtiyacını birkaç adımda tarif et — ev büyüklüğü, tarih ve ek hizmetler. Ücretsiz.",
  nasil_2_title: "Teklifleri karşılaştır",
  nasil_2_desc: "Yakınındaki puanlı uzmanlar talebine teklif gönderir. Fiyatları ve profilleri kıyasla.",
  nasil_3_title: "Anlaş & iletişime geç",
  nasil_3_desc: "Beğendiğin uzmanla mesajlaş, telefonla konuş ve doğrudan anlaş.",
  hizmetler_badge: "Hizmetlerimiz",
  hizmetler_title: "İhtiyacın olan her temizlik",
  hizmetler_sub: "Doğrulanmış uzmanlardan, şeffaf fiyatlarla hizmet kategorileri.",
  neden_badge: "Neden PAK?",
  neden_title: "Güveniniz bizim için önceliktir",
  neden_1_title: "Doğrulanmış uzmanlar",
  neden_1_desc: "Tüm uzmanlar kimlik ve adli sicil kontrolünden geçer.",
  neden_2_title: "Ücretsiz talep",
  neden_2_desc: "Talep oluşturmak tamamen ücretsiz. PAK'a hiçbir ödeme yapmazsınız.",
  neden_3_title: "Teklifleri karşılaştır",
  neden_3_desc: "Birden çok uzmandan teklif alın, fiyat ve profilleri kıyaslayın.",
  neden_4_title: "Gerçek yorumlar",
  neden_4_desc: "Sadece hizmet alan müşterilerden, doğrulanmış değerlendirmeler.",
  saglayicilar_badge: "Öne çıkan uzmanlar",
  saglayicilar_title: "En sevilen uzmanlar",
  yorumlar_badge: "Müşteri Yorumları",
  yorumlar_title: "PAK'çıların sevgiyle anlattıkları",
  sss_badge: "Sıkça Sorulanlar",
  sss_title: "Aklındaki sorulara yanıtlar",
  cta_title_1: "Evinizi",
  cta_title_hl: "PAK",
  cta_title_2: "'lamaya hazır mısınız?",
  cta_sub: "Dakikalar içinde ücretsiz talep oluşturun, uzmanlardan teklif alın.",
  cta_button: "Ücretsiz Talep Oluştur",
  footer_tagline: "Güvenilir temizlik uzmanlarıyla evinizi pırıl pırıl yapın.",
  footer_email: "destek@pak.com.tr",
  footer_phone: "0850 000 00 00",
  footer_copyright: "© 2026 PAK Temizlik. Tüm hakları saklıdır.",
};

export const LANDING_SECTIONS_DEFAULT = [
  { key: "hero", label: "Hero (üst alan)", enabled: true },
  { key: "nasil", label: "Nasıl Çalışır", enabled: true },
  { key: "hizmetler", label: "Hizmetler", enabled: true },
  { key: "neden", label: "Neden PAK", enabled: true },
  { key: "saglayicilar", label: "Öne çıkan uzmanlar", enabled: true },
  { key: "yorumlar", label: "Müşteri yorumları", enabled: true },
  { key: "sss", label: "Sıkça sorulanlar", enabled: true },
  { key: "cta", label: "Alt çağrı bandı (CTA)", enabled: true },
];

// Admin editörü için alanların gruplanışı ve okunur etiketleri.
// { grup başlığı, [ {key, label, multiline?} ] }
export const LANDING_TEXT_GROUPS = [
  {
    title: "Üst menü",
    fields: [
      { key: "nav_book", label: "Talep butonu" },
      { key: "nav_login", label: "Giriş butonu" },
    ],
  },
  {
    title: "Hero (üst alan)",
    fields: [
      { key: "hero_badge", label: "Rozet yazısı" },
      { key: "hero_title_1", label: "Başlık — 1. satır" },
      { key: "hero_title_2", label: "Başlık — 2. satır (yeşil)" },
      { key: "hero_sub", label: "Alt açıklama", multiline: true },
      { key: "hero_cta", label: "Ana buton" },
      { key: "hero_secondary", label: "İkinci buton" },
    ],
  },
  {
    title: "Nasıl Çalışır",
    fields: [
      { key: "nasil_badge", label: "Rozet" },
      { key: "nasil_title", label: "Başlık" },
      { key: "nasil_sub", label: "Alt açıklama", multiline: true },
      { key: "nasil_1_title", label: "Adım 1 — başlık" },
      { key: "nasil_1_desc", label: "Adım 1 — açıklama", multiline: true },
      { key: "nasil_2_title", label: "Adım 2 — başlık" },
      { key: "nasil_2_desc", label: "Adım 2 — açıklama", multiline: true },
      { key: "nasil_3_title", label: "Adım 3 — başlık" },
      { key: "nasil_3_desc", label: "Adım 3 — açıklama", multiline: true },
    ],
  },
  {
    title: "Hizmetler",
    fields: [
      { key: "hizmetler_badge", label: "Rozet" },
      { key: "hizmetler_title", label: "Başlık" },
      { key: "hizmetler_sub", label: "Yan açıklama", multiline: true },
    ],
  },
  {
    title: "Neden PAK",
    fields: [
      { key: "neden_badge", label: "Rozet" },
      { key: "neden_title", label: "Başlık" },
      { key: "neden_1_title", label: "Madde 1 — başlık" },
      { key: "neden_1_desc", label: "Madde 1 — açıklama", multiline: true },
      { key: "neden_2_title", label: "Madde 2 — başlık" },
      { key: "neden_2_desc", label: "Madde 2 — açıklama", multiline: true },
      { key: "neden_3_title", label: "Madde 3 — başlık" },
      { key: "neden_3_desc", label: "Madde 3 — açıklama", multiline: true },
      { key: "neden_4_title", label: "Madde 4 — başlık" },
      { key: "neden_4_desc", label: "Madde 4 — açıklama", multiline: true },
    ],
  },
  {
    title: "Öne çıkan uzmanlar",
    fields: [
      { key: "saglayicilar_badge", label: "Rozet" },
      { key: "saglayicilar_title", label: "Başlık" },
    ],
  },
  {
    title: "Müşteri yorumları",
    fields: [
      { key: "yorumlar_badge", label: "Rozet" },
      { key: "yorumlar_title", label: "Başlık" },
    ],
  },
  {
    title: "Sıkça sorulanlar",
    fields: [
      { key: "sss_badge", label: "Rozet" },
      { key: "sss_title", label: "Başlık" },
    ],
  },
  {
    title: "Alt çağrı bandı (CTA)",
    fields: [
      { key: "cta_title_1", label: "Başlık — 1. bölüm" },
      { key: "cta_title_hl", label: "Başlık — vurgulu kelime (yeşil)" },
      { key: "cta_title_2", label: "Başlık — 3. bölüm" },
      { key: "cta_sub", label: "Alt açıklama", multiline: true },
      { key: "cta_button", label: "Buton" },
    ],
  },
  {
    title: "Footer (alt bilgi)",
    fields: [
      { key: "footer_tagline", label: "Slogan", multiline: true },
      { key: "footer_email", label: "E-posta" },
      { key: "footer_phone", label: "Telefon" },
      { key: "footer_copyright", label: "Telif satırı" },
    ],
  },
];
